import './SelectPanel-1ea8f7c0.css';

var classes = {"Wrapper":"prc-SelectPanel-Wrapper-43Iz8","Content":"prc-SelectPanel-Content-rbAGw","Title":"prc-SelectPanel-Title--CZN1","Subtitle":"prc-SelectPanel-Subtitle-tMSzu","Footer":"prc-SelectPanel-Footer-78rgp","FilteredActionList":"prc-SelectPanel-FilteredActionList-wzS7m"};

export { classes as default };
